const BASE = 'https://propertiesinfinite.com';

const slugify = (s) =>
  String(s || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)+/g, '') || 'view';

/**
 * Copy-link URL for messengers (Telegram / WhatsApp).
 * Served by the API with OG tags + property image; human taps redirect to the listing page.
 */
export function buildPropertyWebShareUrl({ propertyId, categoryName, cityName }) {
  const slug = slugify(`${categoryName || 'property'}-in-${cityName || ''}`);
  return `${BASE}/api/share/listing/${propertyId}/${slug}`;
}

/** Direct website / app deep link (no OG injection). */
export function buildPropertyPageUrl({ propertyId, categoryName, cityName }) {
  const slug = slugify(`${categoryName || 'property'}-in-${cityName || ''}`);
  return `${BASE}/property/${propertyId}/${slug}`;
}

/**
 * Pre-generate the OG cover so WhatsApp/Telegram show the image on the first share.
 * Fire-and-forget — safe to call when the share sheet opens.
 */
export function warmPropertyShareCover(propertyId) {
  const id = Number(propertyId);
  if (!Number.isFinite(id) || id <= 0) return;
  const url = `${BASE}/api/share/listing/${id}/cover.jpg`;
  try {
    fetch(url, { method: 'GET', mode: 'cors', cache: 'no-store', credentials: 'omit' }).catch(
      () => {}
    );
  } catch {
    /* ignore */
  }
}
